import { navItems } from '@/mocks/home';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <span className="font-brand text-2xl text-primary-400">每日吃瓜</span>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed max-w-md">
              每日吃瓜是国内领先的娱乐资讯深度解读平台，专注于明星黑料、黑历史曝光与娱乐圈黑幕深扒。从顶流塌房到综艺翻车，从选秀黑幕到行业潜规则，我们每天为你奉上最新鲜、最劲爆的吃瓜内容。全网黑料一站式聚合，让真相不再沉默。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {navItems.slice(0, 4).map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门专题</h4>
            <ul className="space-y-2.5">
              <li><a href="#cards" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">顶流塌房全记录</a></li>
              <li><a href="#carousel" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">综艺黑幕揭秘</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">吃瓜热榜</a></li>
              <li><a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">热门话题</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800">
          <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
          <p className="text-xs text-foreground-500">更多合作伙伴信息即将上线，敬请期待。</p>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 每日吃瓜. All rights reserved. 仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">用户协议</a>
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}